import React from 'react'

import cx from 'classnames'

import { A } from '@driftt/tide-core'
import { Avatar } from '@driftt/tide-core'

import { dealRoomUrl } from 'utils/paths'
import { humanizedRelativeTime } from 'utils/timeStamp'
import { segmentTrack, TrackType } from 'utils/tracking'

import utilityStyles from '../../styles/utility.module.css'
import styles from './styles.module.css'

interface DealRoomRowProps {
  dealRoom: any
}

interface DealRoomsProps {
  dealRoomsData: any[]
}

const description = (owner: any, size: number) => {
  const ownerName = owner.name || owner.email?.toLowerCase() || 'Anonymous Visitor'

  if (size > 1) {
    return ownerName + ` + ${size - 1} ${size - 1 === 1 ? 'other' : 'others'}`
  }

  return ownerName
}

const DealRoomRow = (props: DealRoomRowProps) => {
  const { id, name, handle, updatedAt, owner, size } = props.dealRoom

  const trackAction = () => segmentTrack(TrackType.GO_TO_DEAL_ROOM_CLICKED)

  return (
    <div className={styles.dealRoom}>
      <p className={cx(styles.dealRoomName, utilityStyles.semiBoldWeight)}>{name}</p>
      <p className={styles.lastUpdated}>{`Last updated ${humanizedRelativeTime(updatedAt)}`}</p>
      <div className={styles.dealRoomMembersContainer}>
        <Avatar user={owner} />
        <span className={styles.dealRoomMembers}>{description(owner, size)}</span>
      </div>
      <A target="_blank" href={dealRoomUrl(handle, id)} onClick={trackAction}>
        <div className={cx(styles.dealRoomLink, utilityStyles.semiBoldWeight)}>
          {`Open ${name}`}
        </div>
      </A>
    </div>
  )
}

export const DealRooms = (props: DealRoomsProps) => {
  const { dealRoomsData } = props

  return (
    <div className={styles.dealRoomsContainer}>
      {dealRoomsData
        .sort((a, b) => b.updatedAt - a.updatedAt)
        .map(room => (
          <DealRoomRow key={room} dealRoom={room} />
        ))}
    </div>
  )
}
